/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Field_Manufactured_DateInputs */

const vi_order_lot_trace_field_manufactured_date = /** @type {(inputs: Order_Lot_Trace_Field_Manufactured_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sản xuất (ngày đóng gói)`)
};

/**

* @param {Order_Lot_Trace_Field_Manufactured_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_field_manufactured_date = /** @type {((inputs?: Order_Lot_Trace_Field_Manufactured_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Field_Manufactured_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_field_manufactured_date(inputs)
});